import React from "react";

interface TableSkeletonProps {
  columns: string[]; // Array of column labels
  rows?: number;
  mainClass?: string;
  subClassName?: string;
}

const TableSkeleton: React.FC<TableSkeletonProps> = ({
  columns,
  rows = 6,
  mainClass = "rounded-r-3xl",
  subClassName = "bg-[#FCFDF8]",
}) => {
  return (
    <div className={` bg-[#F7F6F2] pt-2 ${mainClass} rounded-3xl`}>
      <div
        className={`overflow-auto ${subClassName} rounded-tl-none rounded-3xl `}
      >
        <table className="w-full text-sm">
          <thead className="text-[#131327]/70 border-b border-dashed border-gray-300">
            <tr>
              {columns?.map((label, idx) => (
                <th
                  key={idx}
                  className="text-left font-semibold px-6 py-1 border-r last:border-none border-dashed border-gray-300"
                >
                  {label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: rows }).map((_, rowIdx) => (
              <tr key={rowIdx} className="animate-pulse group cursor-default">
                {columns?.map((_, colIdx) => (
                  <td
                    key={colIdx}
                    className={`px-6 py-5 ${
                      colIdx === 0
                        ? "rounded-l-3xl"
                        : colIdx === columns.length - 1
                        ? "rounded-r-3xl"
                        : ""
                    }`}
                  >
                    <div className="h-4 w-full bg-gray-200 rounded" />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TableSkeleton;
